export default __webpack_public_path__ + "static/media/blackboard.d931c14a.svg";